function Services() {
  return <div className="h-screen bg-purple">Services</div>;
}

export default Services;
